/**
 * Constructs the site-one host URL for a given tenant.
 *
 * Inverse of `resolveTenantFromHost` — builds the host instead of parsing it.
 *
 * - **Production**: `https://{tenant}.one.v.axogroup.com`
 * - **Staging**: `https://{tenant}.one.v.axo-test.io`
 * - **Development / Test**: `http://localhost:3030`
 */
export function getSiteOneHost(
  tenant: string,
  env: 'development' | 'test' | 'staging' | 'production'
): string {
  if (env === 'development' || env === 'test') return 'http://localhost:3030';

  const zone =
    env === 'production' ? 'one.v.axogroup.com' : 'one.v.axo-test.io';

  return `https://${tenant}.${zone}`;
}
